export default __webpack_public_path__ + "static/media/referral.4179ac55.svg";